import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
    providedIn: 'root',
})
export class TranslatedVariables {
    //account-create-account
    account = '';
    commonsAllCountries = '';
    available = '';
    availableIn = '';
    basedOnNumberUsers = '';
    notAvailable = '';
    notAvailableIn = '';
    notIncluded = '';
    includedinbasepackage = '';
    optional = '';
    permissionDenied = '';
    mustBeLogged = '';
    accAlreadyExists = '';
    warningTitle = '';
    errorTitle = '';
    errorSaving = '';
    explanation_line = '';
    snackBarSubTitle = '';
    date = '';
    //account-edit-subscription
    startDialogSubtitle = '';
    endDialogSubtitle = '';
    dialogPlaceHolder_1 = '';
    dialogPlaceHolder_2 = '';
    dialogTitle_2 = '';
    dialogSubTitle_2 = '';
    dialogTitle_3 = '';
    dialogSubTitle_3 = '';
    dialogPlaceHolderFullName = '';
    dialogPlaceHolderEmail = '';
    dialogSubTitle_4_first = '';
    dialogTitle_5 = '';
    dialogSubTitle_5_first = '';
    dialogSubTitle_5_last = '';
    alertMessage = '';
    operationFailed = '';
    dialogSubTitle_6 = '';
    dialogSubTitle_8 = '';
    operationSucceeded = '';
    only_available_some_country = '';
    dialogSubTitle_10 = '';
    dialogSubTitle_11 = '';
    dialogSubTitle_12 = '';
    dialogTitle_13 = '';
    dialogSubTitle_13 = '';
    snackBarMessage_1_first = '';
    snackBarMessage_1_last = '';
    snackBarMessage_2_first = '';
    snackBarMessage_2_middle = '';
    snackBarMessage_2_last = '';
    snackBarSubTitleTwoFactorAuthEmail = '';
    snackBarSubTitleTwoFactorAuthSms = '';
    snackBarSubTitleTwoFactorAuthQrCode = '';
    snackBarSubTitleTwoFactorAuthDisabled = '';
    snackBarSubTitleTwoFactorAuthSubDisabled = '';
    snackBarSubTitleTwoFactorAuthSubEnabled = '';
    // app.component.ts
    dialogSubTitle = '';
    footerSubTitle_1 = '';
    footerSubTitle_2 = '';
    // Incident.component.ts
    snackBarMessage_1 = '';
    errorSending = '';
    errorSendingMail = '';
    dialogIncident_1 = '';
    dialogIncident_2 = '';
    uploadErrorTitle = '';
    uploadError = '';
    uploadErrorMessage = '';
    dialogIncident_3 = '';
    dialogIncident_4 = '';
    dialogIncident_5 = '';
    dialogIncident_6 = '';
    dialogIncident_7 = '';
    safetyNotice = '';
    dialogIncident_8 = '';
    referenceAreas = '';
    //roles.service.ts
    dialogRoles = '';
    //change-password.component.ts
    dialogChangePassword = '';
    //check-code.component.ts
    errorResendMail = '';
    //recupero-credeniali.component.ts
    dialogCredentialsRecovery = '';
    //set-password.component.ts
    dialogSetPassword = '';
    //account-home.component.ts
    errorResetPass = '';
    dialogAccount_1 = '';
    dialogAccount_2 = '';
    dialogAccount_3 = '';
    dialogAccount_4 = '';
    dialogAccount_5 = '';
    //edit-account.component.ts
    dialogSubTitle_first = '';
    dialogSubTitle_last = '';
    titleSubsViewer = '';
    //my-profile.component.ts
    accountSuccessfullyModified = '';
    //Roles-selector.component.ts
    roles = '';
    //Cart-Products.component.ts
    messageTitle = '';
    messageSubTitle = '';
    messageSubTitle_7 = '';
    //Industry-alacarte.component.ts
    popupTitle = '';
    messageLoadings = '';
    quotationOutcome = '';
    //Industry-alacarte-box.component.ts
    messageSubTitle_3 = '';
    //Industry-configurator.component.ts
    messageLoadingsIndustries = '';
    included = '';
    included_2 = '';
    errorUpdating = '';
    errorUpdatingData = '';
    errorCreating = '';
    noIndustryFound = '';
    messageLoadingsDetails = '';
    messageTitle_1 = '';
    messageSubTitle_1 = '';
    messageSubTitle_2 = '';
    messageTitle_3 = '';
    noDescriptionCountries = '';
    messageTitle_5 = '';
    messageSubTitle_6 = '';
    message_1 = '';
    message_2 = '';
    message_5 = '';
    message_4 = '';
    //Checkouts.component.ts
    sendMailDialog_1 = '';
    sendMailDialog_2 = '';
    warningCannotProceed = '';
    customerDataMustBeSaved = '';
    dialogSubTitle_enableAuditing = '';
    dialogSubTitle_disableAuditing = '';
    messageSubtitle_8 = '';
    willBeContactedSoon = '';
    //dati-fatturazione.component.ts
    fieldEmpty = '';
    invalidVATNumber = '';
    invalidVATNumberDesc1 = '';
    invalidVATNumberDesc2 = '';
    invalidVATNumberDesc3 = '';
    invalidVATNumberDesc4 = '';
    invalidVATNumberDesc5 = '';
    invalidVATNumberDesc6 = '';
    invalidVATNumberDesc7 = '';
    invalidVATNumberDesc8 = '';
    invalidVATNumberDesc9 = '';
    invalidVATNumberDesc10 = '';
    //credentials_recovery.component.ts
    mailSent = '';
    mailNotSent = '';
    //other
    commonsCart = '';
    commonsNext = '';
    commonsBack = '';
    commonNrOfUsers = '';
    subscriberAndBillingData = '';
    commonsCompletePurchase = '';
    configurationSummary = '';
    edition = '';
    industry = '';
    country = '';
    commonsHaveSelected = '';
    commonsEmpty = '';
    commonsEmailNotValid = '';
    commonsPasswordMustWatch = '';
    commonsPasswordRegexp = '';
    commonsMinLength = '';
    commonsMaxLength = '';
    commonsZucchettiDealer = '';
    commonsZucchettiCustomer = '';
    commonsInterestedPurchase = '';
    commonsInterestedResale = '';
    commonsOther = '';
    savedQuotation = '';
    orderList = '';
    commonsCodeNotValid = '';
    formErrorPasswordMatch = '';
    configuration = '';
    sessionExpiredTitle = '';
    sessionExpiredMessage = '';
    changeEditionTitle = '';
    changeEditionMessage = '';
    nextPage = '';
    previousPage = '';
    enabled = '';
    disabled = '';
    failed = '';
    service_not_available = '';
    expiredCreditCard = '';
    code = '';
    smsSent = '';
    smsNotSent = '';
    //pdf string
    itemtxt = '';
    featuretxt = '';
    userstxt = '';
    unitPrice = '';
    totalpricetxt = '';
    price_calculated_transactions = '';
    totalCostMonthUsertxt = '';
    totalCost = '';
    commonsVATExcluded = '';
    configurationOf = '';
    pricesDisclaimer = '';
    thanksforvisitingus = '';
    whistlistDialogTitle = '';
    whistlistDialogMessage = '';
    whistlistDialogPlaceHolder = '';
    saveNewQuotation = '';
    gotoNewSubscription = '';
    createYourOwnConfiguration = '';
    goToDashBoard = '';
    goToDashBoardContent = '';
    gotoMagoCloud = '';
    gotoMagoCloudcardContent = '';
    goTo = '';
    orderCompleted = '';
    orderinDraft = '';
    loginlocked = '';
    loginlocked_tryagain = '';
    loginlocked_minute = '';
    loginlocked_minutes = '';
    loginlocked_seconds = '';
    subcriptionCode = '';
    subscriptionDescription = '';
    goToCart = '';
    imp_exp_default_data = '';
    imp_exp_default_Optional_data = '';
    imp_exp_sample_data = '';
    imp_exp_upload_file = '';
    imp_exp_delete_table = '';
    imp_exp_no_overwrite = '';
    imp_exp_yes_overwrite = '';
    imp_exp_connUser_exp = '';
    imp_exp_connUser_imp = '';
    imp_exp_connUser_you_sure = '';
    imp_exp_connUser_title = '';
    yes = '';
    no = '';
    createNewOnPremiseInstance = '';
    createInstance = '';
    instanceCode = '';
    instanceDescription = '';
    instanceFrontEndUrl = '';
    instanceSecurityValue = '';
    successfully_completed = '';
    subscriptionCreated = '';

    DbUnderMaintenance = '';
    NoSubscriptionDatabasesAvailable = '';
    NoInstancesAvailable = '';
    UpdateSubscriptionSuccess = '';
    UpdateSubscriptionDescri = '';
    //userDocumentList
    problemWithSubscriptionData = '';

    enterphonenumber = '';

    filterBy = '';
    orderBy = '';
    weight = '';
    publicationDate = '';
    alphabetic = '';
    all = '';
    executables = '';
    development = '';
    maccresetpwderror = '';
    errorAccountNotValid = '';

    tempde_warningTitle = '';
    tempde_fieldEmpty = '';
    tempde_errorSendingMail = '';
    tempde_operationSucceeded = '';
    tempde_willBeContactedSoon = '';
    tempde_errorTitle = '';
    availableFrom = '';
    availableUntil = '';
    errorReadingCompanyInformation = '';
    totalMLUAmount = '';
    subscription_successfully_activated = '';
    course_add_favourite = '';
    course_delete_favourite = '';
    keyGeneration = '';
    keyGenerationQuestion = '';
    keyGenerationOk = '';
    verticalSolutionsSaved = '';
    verticalSolutionsModified ='';
    mandatoryField = '';
    invalidInputMessage50Nowhitespace = '';
    invalidInputMessage64 = '';
    invalidCryptingFilesExtension = '';
    serialNumbersGeneratioOk = '';
    cryptGenerationOk ='';

    constructor(private translate: TranslateService) {
        this.translate
            .get([
                //for dialog
                'DIALOG.account',
                'DIALOG.permissionDenied',
                'DIALOG.mustBeLogged',
                'DIALOG.accAlreadyExists',
                'DIALOG.warningTitle',
                'DIALOG.errorTitle',
                'DIALOG.errorSaving',
                'DIALOG.snackBarSubTitle',
                'DIALOG.startDialogSubtitle',
                'DIALOG.endDialogSubtitle',
                'DIALOG.dialogPlaceHolder_1',
                'DIALOG.dialogPlaceHolder_2',
                'DIALOG.dialogTitle_2',
                'DIALOG.dialogSubTitle_2',
                'DIALOG.dialogTitle_3',
                'DIALOG.dialogSubTitle_3',
                'DIALOG.dialogPlaceHolderFullName',
                'DIALOG.dialogPlaceHolderEmail',
                'DIALOG.dialogSubTitle_4_first',
                'DIALOG.dialogTitle_5',
                'DIALOG.dialogSubTitle_5_first',
                'DIALOG.dialogSubTitle_5_last',
                'DIALOG.alertMessage',
                'DIALOG.operationFailed',
                'DIALOG.quotationOutcome',
                'DIALOG.dialogSubTitle_6',
                'DIALOG.dialogSubTitle_8',
                'DIALOG.operationSucceeded',
                'DIALOG.dialogSubTitle_10',
                'DIALOG.errorReadingCompanyInformation',
                'DIALOG.dialogSubTitle_11',
                'DIALOG.dialogSubTitle_12',
                'DIALOG.dialogTitle_13',
                'DIALOG.dialogSubTitle_13',
                'DIALOG.snackBarMessage_1_first',
                'DIALOG.snackBarMessage_1_last',
                'DIALOG.snackBarMessage_2_first',
                'DIALOG.snackBarMessage_2_middle',
                'DIALOG.snackBarMessage_2_last',
                'DIALOG.snackBarSubTitleTwoFactorAuthEmail',
                'DIALOG.snackBarSubTitleTwoFactorAuthSms',
                'DIALOG.snackBarSubTitleTwoFactorAuthQrCode',
                'DIALOG.snackBarSubTitleTwoFactorAuthDisabled',
                'DIALOG.snackBarSubTitleTwoFactorAuthSubDisabled',
                'DIALOG.snackBarSubTitleTwoFactorAuthSubEnabled',
                'DIALOG.dialogSubTitle',
                'DIALOG.footerSubTitle_1',
                'DIALOG.footerSubTitle_2',
                'DIALOG.snackBarMessage_1',
                'DIALOG.errorSending',
                'DIALOG.errorSendingMail',
                'DIALOG.dialogIncident_1',
                'DIALOG.dialogIncident_2',
                'DIALOG.uploadErrorMessage',
                'DIALOG.uploadErrorTitle',
                'DIALOG.dialogIncident_3',
                'DIALOG.dialogIncident_4',
                'DIALOG.dialogIncident_5',
                'DIALOG.dialogIncident_6',
                'DIALOG.dialogIncident_7',
                'DIALOG.safetyNotice',
                'DIALOG.dialogIncident_8',
                'DIALOG.referenceAreas',
                'DIALOG.dialogRoles',
                'DIALOG.dialogChangePassword',
                'DIALOG.errorResendMail',
                'DIALOG.dialogCredentialsRecovery',
                'DIALOG.dialogSetPassword',
                'DIALOG.errorResetPass',
                'DIALOG.dialogAccount_1',
                'DIALOG.dialogAccount_2',
                'DIALOG.dialogAccount_3',
                'DIALOG.dialogAccount_4',
                'DIALOG.dialogAccount_5',
                'DIALOG.dialogSubTitle_first',
                'DIALOG.dialogSubTitle_last',
                'DIALOG.titleSubsViewer',
                'DIALOG.accountSuccessfullyModified',
                'DIALOG.roles',
                'DIALOG.messageTitle',
                'DIALOG.messageSubTitle',
                'DIALOG.messageSubTitle_7',
                'DIALOG.popupTitle',
                'DIALOG.messageLoadings',
                'DIALOG.messageSubTitle_3',
                'DIALOG.messageLoadingsIndustries',
                'DIALOG.included',
                'DIALOG.errorUpdating',
                'DIALOG.errorUpdatingData',
                'DIALOG.errorCreating',
                'DIALOG.noIndustryFound',
                'DIALOG.messageLoadingsDetails',
                'DIALOG.messageTitle_1',
                'DIALOG.messageSubTitle_1',
                'DIALOG.messageSubTitle_2',
                'DIALOG.messageTitle_3',
                'DIALOG.noDescriptionCountries',
                'DIALOG.messageTitle_5',
                'DIALOG.messageSubTitle_6',
                'DIALOG.message_1',
                'DIALOG.message_2',
                'DIALOG.message_5',
                'DIALOG.message_4',
                'DIALOG.sendMailDialog_1',
                'DIALOG.sendMailDialog_2',
                'DIALOG.warningCannotProceed',
                'DIALOG.dialogSubTitle_enableAuditing',
                'DIALOG.dialogSubTitle_disableAuditing',
                'DIALOG.messageSubtitle_8',
                'DIALOG.willBeContactedSoon',
                'DIALOG.subscriptionCreated',
                'COMMONS.EXPLANATION_LINE',
                'COMMONS.FIELD_EMPTY',
                'COMMONS.INVALID_VAT_NUMBER',
                'COMMONS.INVALID_VAT_NUMBER_DESC_1',
                'COMMONS.INVALID_VAT_NUMBER_DESC_2',
                'COMMONS.INVALID_VAT_NUMBER_DESC_3',
                'COMMONS.INVALID_VAT_NUMBER_DESC_4',
                'COMMONS.INVALID_VAT_NUMBER_DESC_5',
                'COMMONS.INVALID_VAT_NUMBER_DESC_6',
                'COMMONS.INVALID_VAT_NUMBER_DESC_7',
                'COMMONS.INVALID_VAT_NUMBER_DESC_8',
                'COMMONS.INVALID_VAT_NUMBER_DESC_9',
                'COMMONS.INVALID_VAT_NUMBER_DESC_10',
                'CREDENTIALS_RECOVERY.EMAIL_SENT_TITLE',
                'CREDENTIALS_RECOVERY.EMAIL_NOT_SENT_TITLE',
                'DIALOG.wishlistTitle',
                'DIALOG.wishlistMessage',
                'COMMONS.NAME',
                'DIALOG.CHANGE_EDITION_TITLE',
                'DIALOG.CHANGE_EDITION_MESSAGE',
                'DIALOG.CUSTOMERDATA_MUST_BE_SAVED',
                //not for dialog
                'COMMONS.ALL_COUNTRIES',
                'COMMONS.AVAILABLE',
                'COMMONS.BASED_ON_NUMBERS_USERS',
                'COMMONS.NOT_AVAILABLE',
                'COMMONS.AVAILABLE_IN',
                'COMMONS.NOT_AVAILABLE_IN',
                'COMMONS.NOT_INCLUDED',
                'COMMONS.INCLUDED_2',
                'COMMONS.CART',
                'COMMONS.DATE',
                'COMMONS.NEXT',
                'COMMONS.BACK',
                'COMMONS.FEATURE',
                'COMMONS.ONLY_AVAILABLE_SOME_COUNTRY',
                'INVOICING_DATA.SUBSCRIBER_AND_BILLING_DATA',
                'COMMONS.COMPLETE_PURCHASE',
                'INDUSTRY_CONFIGURATOR.CONFIGURATION_SUMMARY',
                'COMMONS.HAVESELECTED',
                'COMMONS.EMPTY',
                'COMMONS.EMAIL_NOT_VALID',
                'COMMONS.PASSWORD_MUST_MATCH',
                'COMMONS.PASSWORD_REGEXP',
                'COMMONS.MIN_LENGTH',
                'COMMONS.MAX_LENGTH',
                'PURCHASES_ORDERS.SAVED_QUOTATION',
                'PURCHASES_ORDERS.ORDER_LIST',
                'COMMONS.CODE_NOT_VALID',
                'V_ERR_PSW_MATCH',
                'L_CONFIGURATION',
                'COMMONS.NRUSERS',
                'COMMONS.GOTODASHBOARD',
                'COMMONS.GOTODASHBOARDCONTENT',
                'COMMONS.GOTOMAGOCLOUD',
                'COMMONS.GOTOMAGOCLOUDCONTENT',
                'COMMONS.NoInstancesAvailable',
                'COMMONS.NoSubscriptionDatabasesAvailable',
                'COMMONS.DbUnderMaintenance',
                'DIALOG.SESSION_EXPIRED_TITLE',
                'DIALOG.SESSION_EXPIRED_MESSAGE',
                'ENABLED',
                'DISABLED',
                'FAILED',
                'SERVICE_NOT_AVAILABLE',
                'EXPIRED_CREDIT_CARD',
                'OTP.CODE',
                'OTP.SMS_SENT',
                'OTP.SMS_NOT_SENT',
                //pdf string
                'INDUSTRY_CONFIGURATOR.ITEM',
                'SHOPPING.USERS',
                'INDUSTRY_CONFIGURATOR.PRICE_PER_ITEM',
                'INDUSTRY_CONFIGURATOR.PRICE_TOTAL',
                'INDUSTRY_CONFIGURATOR.TOTAL_CONFIGURATION',
                'INDUSTRY_CONFIGURATOR.PER_MONTH',
                'COMMONS.PRICES_VAT_EXCLUDED',
                'INDUSTRY_CONFIGURATOR.CONFIGURATIONOF',
                'INDUSTRY_CONFIGURATOR.PRICESDISCLAIMER',
                'INDUSTRY_CONFIGURATOR.PDFTHANKSVISITINGUS',
                'INDUSTRYALACRTE_CONFIGURATOR.CREATEYOUROWNCONFIGURATION',
                'WISHLSIT.SAVENEWQUOTATION',
                'B_GOTO_NEW_SUB',
                'B_GOTO',
                'L_Optional',
                //
                'COMMONS.ORDERCOMPLETED',
                'COMMONS.ORDERINDRAFT',
                //LOGIN-LOCKED
                'LOGIN.LOGINLOCKED',
                'LOGIN.LOGINLOCKED_TRYAGAIN',
                'LOGIN.LOGINLOCKED_MINUTE',
                'LOGIN.LOGINLOCKED_MINUTES',
                'LOGIN.LOGINLOCKED_SECONDS',
                'COMMONS.DESCRIPTION',
                'EDIT_SUBSCRIPTION.SUBKEY_CODE',
                'EDIT_SUBSCRIPTION.UPDATE_SUBSCRIPTION_SUCCESS',
                'EDIT_SUBSCRIPTION.UPDATE_SUBSCRIPTION_DESCRI',
                'COMMONS.GO_TO_CART',
                'IMPORT_EXPORT_SECTION.DEFAULT_DATA',
                'IMPORT_EXPORT_SECTION.ONLY_DEFAULT_OPTIONAL_DATA',
                'IMPORT_EXPORT_SECTION.SAMPLE_DATA',
                'IMPORT_EXPORT_SECTION.UPLOAD_FILE',
                'IMPORT_EXPORT_SECTION.DELETE_TABLE_CONTENTS',
                'IMPORT_EXPORT_SECTION.OVERWRITE_FIRST_OPTION',
                'IMPORT_EXPORT_SECTION.OVERWRITE_SECOND_OPTION',
                'IMPORT_EXPORT_SECTION.CONNECTED_USERS_EXPORT_DESCR',
                'IMPORT_EXPORT_SECTION.CONNECTED_USERS_IMPORT_DESCR',
                'IMPORT_EXPORT_SECTION.CONNECTED_USERS_YOU_SURE',
                'IMPORT_EXPORT_SECTION.CONNECTED_USERS_TITLE',
                'COMMONS.YES',
                'COMMONS.NO',
                'ON_PREMISE_SECTION.CREATE_NEW_INSTANCE',
                'ON_PREMISE_SECTION.CREATE_INSTANCE',
                'ON_PREMISE_SECTION.INSTANCECODE',
                'ON_PREMISE_SECTION.INSTANCEDESCRIPTION',
                'ON_PREMISE_SECTION.INSTANCEURL',
                'ON_PREMISE_SECTION.INSTANCESECURITYVALUE',
                'COMMONS.PHONE',
                'COMMONS.SUCCESSFULLY_COMPLETED',
                'COMMONS.EDITION',
                'COMMONS.INDUSTRY',
                'COMMONS.COUNTRY',
                'COMMONS.PRICE_CALCULATED_TRANSACTIONS',
                'USERDOCUMENTLIST.PROBELMSWITHSUBSCRIPTION',
                'COMMONS.INCLUDED_IN_BASE_PACKAGE',
                'COMMONS.ZUCCHETTI_DEALER',
                'COMMONS.ZUCCHETTI_CUSTOMER',
                'COMMONS.INTERESTED_PURCHASE',
                'COMMONS.INTERESTED_RESALE',
                'COMMONS.OTHER',
                'M_ACC_RESETPWD_ERROR',

                'TEMP_DE.DIALOG.warningTitle',
                'TEMP_DE.COMMONS.FIELD_EMPTY',
                'TEMP_DE.DIALOG.errorSendingMail',
                'TEMP_DE.DIALOG.operationSucceeded',
                'TEMP_DE.DIALOG.willBeContactedSoon',
                'TEMP_DE.DIALOG.errorTitle',
                'COMMONS.AVAILABLEFROMRELEASE',
                'COMMONS.AVAILABLETORELEASE',
                'COMMONS.TOTALMLUAMOUNT',
                'COMMONS.SUBSCRIPTION_ACTIVATION_SUCCESSFUL',
                'COMMONS.FILTER_BY',
                'COMMONS.ORDER_BY',
                'COMMONS.ALPHABETIC',
                'COMMONS.WEIGHT',
                'COMMONS.PUBLICATION_DATE',
                'COMMONS.ALL',
                'COMMONS.EXECUTABLES',
                'COMMONS.DEVELOPMENT',
                'COMMONS.COURSE_ADD_FAVOURITE',
                'COMMONS.COURSE_DELETE_FAVOURITE',
                'DIALOG.ERRORACCOUNTNOTVALID',
                'COMMONS.KEY_GENERATION',
                'COMMONS.KEY_GENERATION_QUESTION',
                'COMMONS.KEY_GENERATION_OK',
                'COMMONS.VERTICAL_SOLUTIONS_SAVED',
                'COMMONS.VERTICAL_SOLUTIONS_MODIFIED',
                'COMMONS.MANDATORY_FIELD',
                'COMMONS.INVALID_INPUT_MESSAGE_50_NOWHITESPACE',
                'COMMONS.INVALID_INPUT_MESSAGE_64',
                'VERTICAL_SOLUTIONS.CRYPT_FILES_ALLOWED_EXTENSION',
                'COMMONS.SERIAL_NUMBERS_GENERATION_OK',
                'COMMONS.CRYPT_GENERATION_OK'
            ])
            .subscribe((res) => {
                (this.optional = res['L_Optional']), (this.account = res['DIALOG.account']);
                this.permissionDenied = res['DIALOG.permissionDenied'];
                this.mustBeLogged = res['DIALOG.mustBeLogged'];
                this.accAlreadyExists = res['DIALOG.accAlreadyExists'];
                this.warningTitle = res['DIALOG.warningTitle'];
                this.errorTitle = res['DIALOG.errorTitle'];
                this.errorSaving = res['DIALOG.errorSaving'];
                this.snackBarSubTitle = res['DIALOG.snackBarSubTitle'];
                //account-edit-subscription
                this.startDialogSubtitle = res['DIALOG.startDialogSubtitle'];
                this.endDialogSubtitle = res['DIALOG.endDialogSubtitle'];
                this.dialogPlaceHolder_1 = res['DIALOG.dialogPlaceHolder_1'];
                this.dialogPlaceHolder_2 = res['DIALOG.dialogPlaceHolder_2'];
                this.dialogTitle_2 = res['DIALOG.dialogTitle_2'];
                this.dialogSubTitle_2 = res['DIALOG.dialogSubTitle_2'];
                this.dialogTitle_3 = res['DIALOG.dialogTitle_3'];
                this.dialogSubTitle_3 = res['DIALOG.dialogSubTitle_3'];
                this.dialogPlaceHolderFullName = res['DIALOG.dialogPlaceHolderFullName'];
                this.dialogPlaceHolderEmail = res['DIALOG.dialogPlaceHolderEmail'];
                this.dialogSubTitle_4_first = res['DIALOG.dialogSubTitle_4_first'];
                this.dialogTitle_5 = res['DIALOG.dialogTitle_5'];
                this.dialogSubTitle_5_first = res['DIALOG.dialogSubTitle_5_first'];
                this.dialogSubTitle_5_last = res['DIALOG.dialogSubTitle_5_last'];
                this.alertMessage = res['DIALOG.alertMessage'];
                this.operationFailed = res['DIALOG.operationFailed'];
                this.quotationOutcome = res['DIALOG.quotationOutcome'];
                this.dialogSubTitle_6 = res['DIALOG.dialogSubTitle_6'];
                this.dialogSubTitle_8 = res['DIALOG.dialogSubTitle_8'];
                this.operationSucceeded = res['DIALOG.operationSucceeded'];
                this.dialogSubTitle_10 = res['DIALOG.dialogSubTitle_10'];
                this.errorReadingCompanyInformation = res['DIALOG.errorReadingCompanyInformation'];
                this.dialogSubTitle_11 = res['DIALOG.dialogSubTitle_11'];
                this.dialogSubTitle_12 = res['DIALOG.dialogSubTitle_12'];
                this.dialogTitle_13 = res['DIALOG.dialogTitle_13'];
                this.dialogSubTitle_13 = res['DIALOG.dialogSubTitle_13'];
                this.snackBarMessage_1_first = res['DIALOG.snackBarMessage_1_first'];
                this.snackBarMessage_1_last = res['DIALOG.snackBarMessage_1_last'];
                this.snackBarMessage_2_first = res['DIALOG.snackBarMessage_2_first'];
                this.snackBarMessage_2_middle = res['DIALOG.snackBarMessage_2_middle'];
                this.snackBarMessage_2_last = res['DIALOG.snackBarMessage_2_last'];
                this.snackBarSubTitleTwoFactorAuthEmail = res['DIALOG.snackBarSubTitleTwoFactorAuthEmail'];
                this.snackBarSubTitleTwoFactorAuthSms = res['DIALOG.snackBarSubTitleTwoFactorAuthSms'];
                this.snackBarSubTitleTwoFactorAuthQrCode = res['DIALOG.snackBarSubTitleTwoFactorAuthQrCode'];
                this.snackBarSubTitleTwoFactorAuthSubDisabled = res['DIALOG.snackBarSubTitleTwoFactorAuthSubDisabled'];
                this.snackBarSubTitleTwoFactorAuthSubEnabled = res['DIALOG.snackBarSubTitleTwoFactorAuthSubEnabled'];
                this.snackBarSubTitleTwoFactorAuthDisabled = res['DIALOG.snackBarSubTitleTwoFactorAuthDisabled'];
                this.whistlistDialogTitle = res['DIALOG.wishlistTitle'];
                this.whistlistDialogMessage = res['DIALOG.wishlistMessage'];
                this.whistlistDialogPlaceHolder = res['COMMONS.NAME'];
                //app.component.ts
                this.dialogSubTitle = res['DIALOG.dialogSubTitle'];
                this.footerSubTitle_1 = res['DIALOG.footerSubTitle_1'];
                this.footerSubTitle_2 = res['DIALOG.footerSubTitle_2'];
                //Incident.component.ts
                this.snackBarMessage_1 = res['DIALOG.snackBarMessage_1'];
                this.errorSending = res['DIALOG.errorSending'];
                this.errorSendingMail = res['DIALOG.errorSendingMail'];
                this.dialogIncident_1 = res['DIALOG.dialogIncident_1'];
                this.dialogIncident_2 = res['DIALOG.dialogIncident_2'];
                this.uploadError = res['DIALOG.uploadError'];
                this.uploadErrorTitle = res['DIALOG.uploadErrorTitle'];
                this.uploadErrorMessage = res['DIALOG.uploadErrorMessage'];
                this.dialogIncident_3 = res['DIALOG.dialogIncident_3'];
                this.dialogIncident_4 = res['DIALOG.dialogIncident_4'];
                this.dialogIncident_5 = res['DIALOG.dialogIncident_5'];
                this.dialogIncident_6 = res['DIALOG.dialogIncident_6'];
                this.dialogIncident_7 = res['DIALOG.dialogIncident_7'];
                this.safetyNotice = res['DIALOG.safetyNotice'];
                this.dialogIncident_8 = res['DIALOG.dialogIncident_8'];
                this.referenceAreas = res['DIALOG.referenceAreas'];
                // roles.service.ts
                this.dialogRoles = res['DIALOG.dialogRoles'];
                //change-password.component.ts
                this.dialogChangePassword = res['DIALOG.dialogChangePassword'];
                //check-code.component.ts
                this.errorResendMail = res['DIALOG.errorResendMail'];
                //recupero-credenziali.component.ts
                this.dialogCredentialsRecovery = res['DIALOG.dialogCredentialsRecovery'];
                //set-password.component.ts
                this.dialogSetPassword = res['DIALOG.dialogSetPassword'];
                //change edition
                this.changeEditionTitle = res['DIALOG.CHANGE_EDITION_TITLE'];
                this.changeEditionMessage = res['DIALOG.CHANGE_EDITION_MESSAGE'];
                //paginator
                this.nextPage = res['NEXT_PAGE'];
                this.previousPage = res['PREVIOUS_PAGE'];
                //account-home.component.ts
                this.errorResetPass = res['DIALOG.errorResetPass'];
                this.dialogAccount_1 = res['DIALOG.dialogAccount_1'];
                this.dialogAccount_2 = res['DIALOG.dialogAccount_2'];
                this.dialogAccount_3 = res['DIALOG.dialogAccount_3'];
                this.dialogAccount_4 = res['DIALOG.dialogAccount_4'];
                this.dialogAccount_5 = res['DIALOG.dialogAccount_5'];
                //edit-account.component.ts
                this.dialogSubTitle_first = res['DIALOG.dialogSubTitle_first'];
                this.dialogSubTitle_last = res['DIALOG.dialogSubTitle_last'];
                this.titleSubsViewer = res['DIALOG.titleSubsViewer'];
                //my-profile.component.ts
                this.accountSuccessfullyModified = res['DIALOG.accountSuccessfullyModified'];
                //Roles-selector.component.ts
                this.roles = res['DIALOG.roles'];
                //Cart-Products.component.ts
                this.messageTitle = res['DIALOG.messageTitle'];
                this.messageSubTitle = res['DIALOG.messageSubTitle'];
                this.messageSubTitle_7 = res['DIALOG.messageSubTitle_7'];
                //Industry-alacarte.component.ts
                this.popupTitle = res['DIALOG.popupTitle'];
                this.messageLoadings = res['DIALOG.messageLoadings'];
                this.messageSubTitle_3 = res['DIALOG.messageSubTitle_3'];
                //Industry-configurator.component.ts
                this.messageLoadingsIndustries = res['DIALOG.messageLoadingsIndustries'];
                this.included = res['DIALOG.included'];
                this.included_2 = res['COMMONS.INCLUDED_2'];
                this.errorUpdating = res['DIALOG.errorUpdating'];
                this.errorUpdatingData = res['DIALOG.errorUpdatingData'];
                this.errorCreating = res['DIALOG.errorCreating'];
                this.noIndustryFound = res['DIALOG.noIndustryFound'];
                this.messageLoadingsDetails = res['DIALOG.messageLoadingsDetails'];
                this.messageTitle_1 = res['DIALOG.messageTitle_1'];
                this.messageSubTitle_1 = res['DIALOG.messageSubTitle_1'];
                this.messageSubTitle_2 = res['DIALOG.messageSubTitle_2'];
                this.messageTitle_3 = res['DIALOG.messageTitle_3'];
                this.noDescriptionCountries = res['DIALOG.noDescriptionCountries'];
                this.messageTitle_5 = res['DIALOG.messageTitle_5'];
                this.messageSubTitle_6 = res['DIALOG.messageSubTitle_6'];
                this.message_1 = res['DIALOG.message_1'];
                this.message_2 = res['DIALOG.message_2'];
                this.message_5 = res['DIALOG.message_5'];
                this.message_4 = res['DIALOG.message_4'];
                this.sendMailDialog_1 = res['DIALOG.sendMailDialog_1'];
                this.sendMailDialog_2 = res['DIALOG.sendMailDialog_2'];
                this.warningCannotProceed = res['DIALOG.warningCannotProceed'];
                this.dialogSubTitle_disableAuditing = res['DIALOG.dialogSubTitle_enableAuditing'];
                this.messageSubtitle_8 = res['DIALOG.messageSubtitle_8'];
                this.willBeContactedSoon = res['DIALOG.willBeContactedSoon'];
                this.dialogSubTitle_enableAuditing = res['DIALOG.dialogSubTitle_enableAuditing'];
                //dati-fatturazione.component.ts
                this.fieldEmpty = res['COMMONS.FIELD_EMPTY'];
                this.invalidVATNumber = res['COMMONS.INVALID_VAT_NUMBER'];
                this.invalidVATNumberDesc1 = res['COMMONS.INVALID_VAT_NUMBER_DESC_1'];
                this.invalidVATNumberDesc2 = res['COMMONS.INVALID_VAT_NUMBER_DESC_2'];
                this.invalidVATNumberDesc3 = res['COMMONS.INVALID_VAT_NUMBER_DESC_3'];
                this.invalidVATNumberDesc4 = res['COMMONS.INVALID_VAT_NUMBER_DESC_4'];
                this.invalidVATNumberDesc5 = res['COMMONS.INVALID_VAT_NUMBER_DESC_5'];
                this.invalidVATNumberDesc6 = res['COMMONS.INVALID_VAT_NUMBER_DESC_6'];
                this.invalidVATNumberDesc7 = res['COMMONS.INVALID_VAT_NUMBER_DESC_7'];
                this.invalidVATNumberDesc8 = res['COMMONS.INVALID_VAT_NUMBER_DESC_8'];
                this.invalidVATNumberDesc9 = res['COMMONS.INVALID_VAT_NUMBER_DESC_9'];
                this.invalidVATNumberDesc10 = res['COMMONS.INVALID_VAT_NUMBER_DESC_10'];
                //credentials-recovery.component.ts
                this.mailSent = res['CREDENTIALS_RECOVERY.EMAIL_SENT_TITLE'];
                this.mailNotSent = res['CREDENTIALS_RECOVERY.EMAIL_NOT_SENT_TITLE'];
                //other
                this.notIncluded = res['COMMONS.NOT_INCLUDED'];
                this.only_available_some_country = res['COMMONS.ONLY_AVAILABLE_SOME_COUNTRY'];
                this.basedOnNumberUsers = res['COMMONS.BASED_ON_NUMBERS_USERS'];
                this.commonsCart = res['COMMONS.CART'];
                this.available = res['COMMONS.AVAILABLE'];
                this.notAvailable = res['COMMONS.NOT_AVAILABLE'];
                this.availableIn = res['COMMONS.AVAILABLE_IN'];
                this.notAvailableIn = res['COMMONS.NOT_AVAILABLE_IN'];
                this.commonsNext = res['COMMONS.NEXT'];
                this.commonsBack = res['COMMONS.BACK'];
                this.date = res['COMMONS.DATE'];
                this.explanation_line = res['COMMONS.EXPLANATION_LINE'];
                this.subscriberAndBillingData = res['INVOICING_DATA.SUBSCRIBER_AND_BILLING_DATA'];
                this.commonsCompletePurchase = res['COMMONS.COMPLETE_PURCHASE'];
                this.configurationSummary = res['INDUSTRY_CONFIGURATOR.CONFIGURATION_SUMMARY'];
                this.edition = res['COMMONS.EDITION'];
                this.industry = res['COMMONS.INDUSTRY'];
                this.country = res['COMMONS.COUNTRY'];
                this.commonsHaveSelected = res['COMMONS.HAVESELECTED'];
                this.commonsEmpty = res['COMMONS.EMPTY'];
                this.commonsEmailNotValid = res['COMMONS.EMAIL_NOT_VALID'];
                this.commonsPasswordMustWatch = res['COMMONS.PASSWORD_MUST_MATCH'];
                this.commonsPasswordRegexp = res['COMMONS.PASSWORD_REGEXP'];
                this.commonsMinLength = res['COMMONS.MIN_LENGTH'];
                this.commonsMaxLength = res['COMMONS.MAX_LENGTH'];
                this.savedQuotation = res['PURCHASES_ORDERS.SAVED_QUOTATION'];
                this.orderList = res['PURCHASES_ORDERS.ORDER_LIST'];
                this.commonsCodeNotValid = res['COMMONS.CODE_NOT_VALID'];
                this.formErrorPasswordMatch = res['V_ERR_PSW_MATCH'];
                this.configuration = res['L_CONFIGURATION'];
                this.sessionExpiredTitle = res['DIALOG.SESSION_EXPIRED_TITLE'];
                this.sessionExpiredMessage = res['DIALOG.SESSION_EXPIRED_MESSAGE'];
                this.enabled = res['ENABLED'];
                this.disabled = res['DISABLED'];
                this.failed = res['FAILED'];
                this.service_not_available = res['SERVICE_NOT_AVAILABLE'];
                this.expiredCreditCard = res['EXPIRED_CREDIT_CARD'];
                this.code = res['OTP.CODE'];
                this.smsSent = res['OTP.SMS_SENT'];
                this.smsNotSent = res['OTP.SMS_NOT_SENT'];
                //pdf string
                this.itemtxt = res['INDUSTRY_CONFIGURATOR.ITEM'];
                this.featuretxt = res['COMMONS.FEATURE'];
                this.userstxt = res['SHOPPING.USERS'];
                this.unitPrice = res['INDUSTRY_CONFIGURATOR.PRICE_PER_ITEM'];
                this.totalpricetxt = res['INDUSTRY_CONFIGURATOR.PRICE_TOTAL'];
                this.price_calculated_transactions = res['COMMONS.PRICE_CALCULATED_TRANSACTIONS'];
                this.totalCost = res['INDUSTRY_CONFIGURATOR.TOTAL_CONFIGURATION'];
                this.totalCostMonthUsertxt =
                    res['INDUSTRY_CONFIGURATOR.TOTAL_CONFIGURATION'] + '  ' + res['INDUSTRY_CONFIGURATOR.PER_MONTH'];
                this.commonsVATExcluded = res['COMMONS.PRICES_VAT_EXCLUDED'];
                this.configurationOf = res['INDUSTRY_CONFIGURATOR.CONFIGURATIONOF'];
                this.pricesDisclaimer = res['INDUSTRY_CONFIGURATOR.PRICESDISCLAIMER'];
                this.thanksforvisitingus = res['INDUSTRY_CONFIGURATOR.PDFTHANKSVISITINGUS'];
                this.commonNrOfUsers = res['COMMONS.NRUSERS'];
                this.saveNewQuotation = res['WISHLSIT.SAVENEWQUOTATION'];
                this.gotoNewSubscription = res['B_GOTO_NEW_SUB'];
                this.createYourOwnConfiguration = res['INDUSTRYALACRTE_CONFIGURATOR.CREATEYOUROWNCONFIGURATION'];
                this.goToDashBoard = res['COMMONS.GOTODASHBOARD'];
                this.goToDashBoardContent = res['COMMONS.GOTODASHBOARDCONTENT'];
                this.gotoMagoCloud = res['COMMONS.GOTOMAGOCLOUD'];
                this.gotoMagoCloudcardContent = res['COMMONS.GOTOMAGOCLOUDCONTENT'];
                this.NoInstancesAvailable = res['COMMONS.NoInstancesAvailable'];
                this.NoSubscriptionDatabasesAvailable = res['COMMONS.NoSubscriptionDatabasesAvailable'];
                this.DbUnderMaintenance = res['COMMONS.DbUnderMaintenance'];
                this.goTo = res['B_GOTO'];
                //
                this.orderCompleted = res['COMMONS.ORDERCOMPLETED'];
                this.orderinDraft = res['COMMONS.ORDERINDRAFT'];
                //LOGIN LOCKED
                this.loginlocked = res['LOGIN.LOGINLOCKED'];
                this.loginlocked_tryagain = res['LOGIN.LOGINLOCKED_TRYAGAIN'];
                this.loginlocked_minute = res['LOGIN.LOGINLOCKED_MINUTE'];
                this.loginlocked_minutes = res['LOGIN.LOGINLOCKED_MINUTES'];
                this.loginlocked_seconds = res['LOGIN.LOGINLOCKED_SECONDS'];
                this.subscriptionDescription = res['COMMONS.DESCRIPTION'];
                this.subcriptionCode = res['EDIT_SUBSCRIPTION.SUBKEY_CODE'];
                this.goToCart = res['COMMONS.GO_TO_CART'];
                this.customerDataMustBeSaved = res['DIALOG.CUSTOMERDATA_MUST_BE_SAVED'];
                this.createInstance = res['ON_PREMISE_SECTION.CREATE_INSTANCE'];
                this.createNewOnPremiseInstance = res['ON_PREMISE_SECTION.CREATE_NEW_INSTANCE'];
                this.instanceCode = res['ON_PREMISE_SECTION.INSTANCECODE'];
                this.instanceDescription = res['ON_PREMISE_SECTION.INSTANCEDESCRIPTION'];
                this.instanceFrontEndUrl = res['ON_PREMISE_SECTION.INSTANCEURL'];
                this.instanceSecurityValue = res['ON_PREMISE_SECTION.INSTANCESECURITYVALUE'];
                // #region IMPORT-EXPORT
                this.imp_exp_default_data = res['IMPORT_EXPORT_SECTION.DEFAULT_DATA'];
                this.imp_exp_default_Optional_data = res['IMPORT_EXPORT_SECTION.ONLY_DEFAULT_OPTIONAL_DATA'];
                this.imp_exp_sample_data = res['IMPORT_EXPORT_SECTION.SAMPLE_DATA'];
                this.imp_exp_upload_file = res['IMPORT_EXPORT_SECTION.UPLOAD_FILE'];
                this.imp_exp_delete_table = res['IMPORT_EXPORT_SECTION.DELETE_TABLE_CONTENTS'];
                this.imp_exp_no_overwrite = res['IMPORT_EXPORT_SECTION.OVERWRITE_FIRST_OPTION'];
                this.imp_exp_yes_overwrite = res['IMPORT_EXPORT_SECTION.OVERWRITE_SECOND_OPTION'];
                this.imp_exp_connUser_exp = res['IMPORT_EXPORT_SECTION.CONNECTED_USERS_EXPORT_DESCR'];
                this.imp_exp_connUser_imp = res['IMPORT_EXPORT_SECTION.CONNECTED_USERS_IMPORT_DESCR'];
                this.imp_exp_connUser_you_sure = res['IMPORT_EXPORT_SECTION.CONNECTED_USERS_YOU_SURE'];
                this.imp_exp_connUser_title = res['IMPORT_EXPORT_SECTION.CONNECTED_USERS_TITLE'];
                // #endregion imp-exp
                this.yes = res['COMMONS.YES'];
                this.no = res['COMMONS.NO'];
                this.enterphonenumber = res['COMMONS.PHONE'];
                this.successfully_completed = res['COMMONS.SUCCESSFULLY_COMPLETED'];
                this.UpdateSubscriptionSuccess = res['EDIT_SUBSCRIPTION.UPDATE_SUBSCRIPTION_SUCCESS'];
                this.UpdateSubscriptionDescri = res['EDIT_SUBSCRIPTION.UPDATE_SUBSCRIPTION_DESCRI'];
                this.problemWithSubscriptionData = res['USERDOCUMENTLIST.PROBELMSWITHSUBSCRIPTION'];
                this.includedinbasepackage = res['COMMONS.INCLUDED_IN_BASE_PACKAGE'];
                this.commonsZucchettiDealer = res['COMMONS.ZUCCHETTI_DEALER'];
                this.commonsZucchettiCustomer = res['COMMONS.ZUCCHETTI_CUSTOMER'];
                this.commonsInterestedPurchase = res['COMMONS.INTERESTED_PURCHASE'];
                this.commonsInterestedResale = res['COMMONS.INTERESTED_RESALE'];
                this.commonsOther = res['COMMONS.OTHER'];
                this.maccresetpwderror = res['M_ACC_RESETPWD_ERROR'];

                this.tempde_warningTitle = res['TEMP_DE.DIALOG.warningTitle'];
                this.tempde_fieldEmpty = res['TEMP_DE.COMMONS.FIELD_EMPTY'];
                this.tempde_errorSendingMail = res['TEMP_DE.DIALOG.errorSendingMail'];
                this.tempde_operationSucceeded = res['TEMP_DE.DIALOG.operationSucceeded'];
                this.tempde_willBeContactedSoon = res['TEMP_DE.DIALOG.willBeContactedSoon'];
                this.tempde_errorTitle = res['TEMP_DE.DIALOG.errorTitle'];
                this.subscriptionCreated = res['DIALOG.subscriptionCreated'];
                this.availableFrom = res['COMMONS.AVAILABLEFROMRELEASE'];
                this.availableUntil = res['COMMONS.AVAILABLETORELEASE'];
                this.totalMLUAmount = res['COMMONS.TOTALMLUAMOUNT'];
                this.subscription_successfully_activated = res['COMMONS.SUBSCRIPTION_ACTIVATION_SUCCESSFUL'];
                this.commonsAllCountries = res['COMMONS.ALL_COUNTRIES'];
                this.filterBy = res['COMMONS.FILTER_BY'];
                this.orderBy = res['COMMONS.ORDER_BY'];
                this.weight = res['COMMONS.WEIGHT'];
                this.publicationDate = res['COMMONS.PUBLICATION_DATE'];
                this.alphabetic = res['COMMONS.ALPHABETIC'];
                this.all = res['COMMONS.ALL'];
                this.executables = res['COMMONS.EXECUTABLES'];
                this.development = res['COMMONS.DEVELOPMENT'];
                this.course_add_favourite = res['COMMONS.COURSE_ADD_FAVOURITE'];
                this.course_delete_favourite = res['COMMONS.COURSE_DELETE_FAVOURITE'];
                this.errorAccountNotValid = res['DIALOG.ERRORACCOUNTNOTVALID'];
                this.keyGeneration = res['COMMONS.KEY_GENERATION'];
                this.keyGenerationQuestion = res['COMMONS.KEY_GENERATION_QUESTION'];
                this.keyGenerationOk = res['COMMONS.KEY_GENERATION_OK'];
                this.verticalSolutionsSaved = res['COMMONS.VERTICAL_SOLUTIONS_SAVED'];
                this.verticalSolutionsModified = res['COMMONS.VERTICAL_SOLUTIONS_MODIFIED'];
                this.mandatoryField = res['COMMONS.MANDATORY_FIELD'];
                this.invalidInputMessage50Nowhitespace = res['COMMONS.INVALID_INPUT_MESSAGE_50_NOWHITESPACE'];
                this.invalidInputMessage64 = res['COMMONS.INVALID_INPUT_MESSAGE_64'];
                this.invalidCryptingFilesExtension = res['VERTICAL_SOLUTIONS.CRYPT_FILES_ALLOWED_EXTENSION'];
                this.serialNumbersGeneratioOk = res['COMMONS.SERIAL_NUMBERS_GENERATION_OK'];
                this.cryptGenerationOk = res['COMMONS.CRYPT_GENERATION_OK']
            });
    }
}
